var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinishStep(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_743_41781",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_743_41781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.641 13.3331H4.94872V5.9998L9.1282 1.87158L9.42308 2.16647C9.48376 2.22714 9.53483 2.30492 9.57628 2.3998C9.61774 2.49467 9.63847 2.58184 9.63847 2.66133V2.76647L8.95642 5.9998H13.5898C13.8684 5.9998 14.1175 6.10963 14.3372 6.32928C14.5568 6.54894 14.6667 6.79808 14.6667 7.07672V7.89723C14.6667 7.95792 14.6598 8.02416 14.6461 8.09595C14.6325 8.16775 14.6145 8.23399 14.5923 8.29467L12.7718 12.6101C12.6803 12.8152 12.5265 12.987 12.3103 13.1254C12.094 13.2639 11.8709 13.3331 11.641 13.3331ZM5.61538 12.6665H11.641C11.735 12.6665 11.8312 12.6408 11.9295 12.5895C12.0278 12.5383 12.1026 12.4528 12.1538 12.3331L14 7.9998V7.07672C14 6.95706 13.9615 6.85877 13.8846 6.78185C13.8077 6.70493 13.7094 6.66647 13.5898 6.66647H8.1282L8.9 3.02543L5.61538 6.28442V12.6665ZM4.94872 5.9998V6.66647H2.66667V12.6665H4.94872V13.3331H2V5.9998H4.94872Z",
    fill: "#239D45"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishStep);
export default __webpack_public_path__ + "static/media/finishStep.3401fb985e9050fed6ff2256cb1fa487.svg";
export { ForwardRef as ReactComponent };